export const routing = {
  locales: ['en', 'ar', 'pt', 'es', 'ru', 'zh', 'vi'], // Added Kurdish
  defaultLocale: 'en', // Arabic as default
  localePrefix: 'as-needed', // Only non-default locale shows in URL
};
